import { caseInsensitiveCompare } from '@/utils/util'

export function getTableColumnSelectOptions(tableData: object[], columnName: string) {
    const values = tableData.map(row => row[columnName]);
    return getFilterSelectOptions(values);
}

function getFilterSelectOptions(values: string[]) {
    return new Set(values
        .filter(field => !!field)
        .sort(caseInsensitiveCompare)
    )
}